import React, { useState, useEffect, useRef, forwardRef } from 'react';
import './App.css';
import './Drawcanvas.css';
import CanvasDraw from 'react-canvas-draw';
import { useDispatch, useSelector } from 'react-redux';
import { updateDrawing, updateTurn } from './redux/gameState';

let saveableCanvas = null;

function Canvas(props, ref) {

  // adjust to only load drawing into a disabled canvas

  // add setTimeout to delay ability to draw for a second after it is your turn..? Issue might be that I am going too fast?

  const [isDrawing, setIsDrawing] = useState(false);
  const [cWidth, setCWidth] = useState(400);
  const [color, setColor] = useState('#282c34');
  const [strokes, setStrokes] = useState(0);
  const [brushSize, setSize] = useState(12);
  const [disabled, setDisabled] = useState(false);
  const canvasContainer = useRef();
  const [mouseX, setX] = useState(0);
  const [mouseY, setY] = useState(0);
  const [socket, setSocket] = useState(props.socket);
  const ps = useSelector((state) => state.playerState);
  const gameState = useSelector((state) => state.gameState);
  const configState = useSelector((state) => state.configState);
  const canvasC = useRef();
  const dispatch = useDispatch();
  let turnTimeout;

  useEffect(() => {
    let containerW = (canvasContainer.current.offsetWidth > 650) ? 650 : canvasContainer.current.offsetWidth;
    setCWidth(Math.round(containerW));
    setColor(ps.colour);
  }, []);

  const resizingDelayTimer = useRef();

  useEffect(() => {
    clearTimeout(turnTimeout);
    const observer = new ResizeObserver((entries) => {
      // without timout, resize observer loop will entounter errors
      clearTimeout(resizingDelayTimer.current);
      resizingDelayTimer.current = setTimeout(() => {
        // check if the observed div is still mounted
        // else this will cause memory leak   
        if (canvasContainer.current && !isDrawing) {
          for (let entry of entries) {
            if (Math.round(entry.contentRect.width) == cWidth) {
              return;
            }
            const dr = saveableCanvas.getSaveData();
            let newWidth = (entry.contentRect.width < 400) ? 400 : entry.contentRect.width;
            setCWidth(Math.round(newWidth));
            saveableCanvas.loadSaveData(dr, true);
          }
          }
      }, 100)
    });

    observer.observe(canvasContainer.current);
    // Cleanup function
    return () => {
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    if (props.countdownFinished) {
      // no effect disabling manually, if it is even working
      saveableCanvas.isDisabled = true;
      setDisabled(true);
      // points are sometimes an empty array, causing errors
      let muEvent = new MouseEvent('mouseUp', {
        view: window,
        bubbles: true,
        cancelable: true,
        clientX: mouseX,
        clientY: mouseY
      });
      let tuEvent = new TouchEvent('touchend', {
        view: window,
        bubbles: true,
        cancelable: true,
        clientX: mouseX,
        clientY: mouseY
      });

      saveableCanvas.handleDrawEnd(muEvent);
      saveableCanvas.handleDrawEnd(tuEvent);
      saveableCanvas.isDisabled = true;
      setStrokes(0);
      props.startTurn(false);
      setDisabled(true);
      socket.emit("newDrawing", saveableCanvas.getSaveData());
      // }, 100);
    }
  }, [props.countdownFinished]);

  function trackMouseCoords(evt) {
    evt.persist();
    if (!disabled) {
      let xCoord = evt.clientX;
      let yCoord = evt.clientY;
      if (evt.type == "touchmove") {
        xCoord = evt.touches[0].clientX
        yCoord = evt.touches[0].clientY
      }
      setX(xCoord);
      setY(yCoord);
    }
  }

  useEffect(() => {
    setSocket(props.socket);
  }, [props.socket]);

  useEffect(() => {
    clearTimeout(turnTimeout);
    let turn = gameState.turn;
    // check if player whose turn it is has not left
    // index >= 0 && index < array.length;
    if ((gameState.players[turn] != null && gameState.players[turn].id !== ps.id) || gameState.voting) {
      setStrokes(0);
      setDisabled(true);
    }
    else {
      // need this timeout when changing turn otherwise drawing too quick breaks canvas
      turnTimeout = setTimeout(() => {
        setDisabled(false);
        clearTimeout(turnTimeout);
      }, 1000);
    }
  }, [gameState, ps.id]);

  const changeHandler = (saveData, e) => {
    e.persist();
    if (disabled) {
      return;
    }
    if ((strokes + 1) < configState.strokes) {
      setStrokes(strokes + 1);
      return;
    }
    setIsDrawing(false);
    props.startTurn(false);
    setStrokes(0);
    socket.emit("newDrawing", saveData);
    dispatch(updateTurn((gameState.turn + 1)));
  }

  const startTurn = (saveableCanvas, e) => {
    e.persist();
    if (disabled) {
      return;
    }
    setIsDrawing(true);
    // added below to update drawing for players every second
    // need further testing
    props.startTurn(true);
  }

  useEffect(() => {
    socket.once("updateDrawing", (drawing) => {
      if (drawing === null || !drawing) {
        return;
      }
      dispatch(updateDrawing(drawing));
      saveableCanvas.loadSaveData(drawing, true);
      dispatch(updateTurn(gameState.turn + 1));
    });
    return () => {
      socket.off('updateDrawing');
    };
  });

  return (
    <div ref={canvasC} className="canvas ">
      {/* put this all in its own component */}
      <div className="slidecontainer grid-cols-12 grid w-full">
        <p className='text-md md:text-xl col-span-6'>Room Code: {gameState.room}</p>
        <p className='text-sm md:text-lg xl:text-xl col-span-6'>Secret Word: {(ps.faker) ? 'XXX' : gameState.word}</p>
        <div className='col-span-12'>
          <label className='text-md md:text-xl'>Pencil size: </label>
          <input type="range" min="1" max="12" className="playerPencilSize transform scale-75 md:scale-100" onChange={e => setSize(Number(e.target.value))} />
        </div>
      </div>
      {/* touch controls do not work on canvas*/}
      <div ref={canvasContainer} className={"canvasContainer self-center content-center"}
        onTouchMove={(e) => trackMouseCoords(e)}
        onMouseMove={(e) => trackMouseCoords(e)}
        onTouchEnd={(e) => changeHandler(saveableCanvas.getSaveData(), e)}
        onTouchStart={(e) => startTurn(saveableCanvas.getSaveData(), e)}
        onMouseUp={(e) => changeHandler(saveableCanvas.getSaveData(), e)}
        onMouseDown={(e) => startTurn(saveableCanvas.getSaveData(), e)}>
        <CanvasDraw canvasHeight={cWidth} canvasWidth={cWidth}
          disabled={disabled} className="rounded canvasDraw static"
          ref={CanvasDraw => (saveableCanvas = CanvasDraw)}
          brushColor={color} brushRadius={brushSize}
          tabIndex={0} hideGrid
        />
      </div>
    </div>
  );
}

const Drawcanvas = forwardRef(Canvas);

export default Drawcanvas;